import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import MainModal from 'components/ModalMain';
import TextArea from 'components/TextArea';
import Button from 'components/Button';
import Dropdown from 'components/Dropdown';
import { Head, Container, Description, Title, SettingLink, Footer } from './styles';

const ModalReplyFromDashboard = ({hidden, iconStyle, buttonIcon, tenantId }) => {

  const navigate = useNavigate()
  const [isOpen, setIsOpen] = useState(false)
  const [replyOption, setReplyOption] = useState('Email')
  //FIXME: update this when the backend is ready
  const loading = false
  const handleReply = () => {
    if(loading) return
    //TODO: Implement reply logic
  }

  return (
    <MainModal
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      className="modal-success"
      iconStyle={iconStyle}
      buttonIcon={buttonIcon}
      hidden={hidden}
      additionalstyle={`
        max-width: 635px;
        .modal-content{
          height: 412px;
          .close {
            z-index: 200;
          }      
          .modal-body {
            position: relative;
            top: 20px;
            height: 100%;
          }
        }
        top: 123px;
      `}
    >
      <Head>Reply to this message:</Head>
      <Description>
        <Title>Nancy Hachisu (via email): </Title>        
        This is a message about lorem ipsum dolor sit amet, consectetur adipiscing
        elit, yada yada yada… This is a message about lorem ipsum dolor sit amet,
        consectetur adipiscing elit, yada yada yada…
        <SettingLink
          to={`/tenant-details/${tenantId}`}
        >
          Read more {'>'}
        </SettingLink>
      </Description>
      <Container>
        <TextArea
          title="REPLY"
          onChange={(e) => { }}
          additionalstyle={`
            flex-basis: 100%;
            
            textarea {
              min-height:80px;
            }
          `}
        />
      </Container>
      <Footer>
        <Dropdown
          options={['Email', 'Text Message', 'Chat']}
          value={replyOption}
          title="SEND AS"
          onChange={(e) => setReplyOption(e.target.value)}
          additionalstyle={`
            width: 30%;
          `}
        />
        <Button
          success
          onClick={handleReply}
          data-loading={loading}
          additionalstyle={`
            width: 130px;
          `}
        >
          {loading? null: 'Submit'}
        </Button>
      </Footer>
    </MainModal>
  )
}

export default ModalReplyFromDashboard;
